export const claimsQueryKeys = {
  all: ['claims'] as const,
  campaigns: () => [...claimsQueryKeys.all, 'campaigns'] as const,
  approvalRequestsBase: (campaignId: string) => [...claimsQueryKeys.all, 'approval-requests', campaignId] as const,
  approvalRequests: (campaignId: string, status?: string, page?: number, pageSize?: number, customerId?: string) =>
    [...claimsQueryKeys.approvalRequestsBase(campaignId), status, page, pageSize, customerId] as const,
  campaignEnrollmentsBase: (campaignId: string) =>
    [...claimsQueryKeys.all, 'campaign-enrollments', campaignId] as const,
  campaignEnrollments: (campaignId: string, state?: string, page?: number, pageSize?: number, customerId?: string) =>
    [...claimsQueryKeys.campaignEnrollmentsBase(campaignId), state, page, pageSize, customerId] as const,
};
